module.exports = __webpack_public_path__ + "img/posted.e2536e9d.svg";